<template>
    <div>
        <md-list>
            <md-list-item v-for="asset in assetsList" :key="asset.name" class="md-layout">
                <div class="md-list-item-text md-layout-item">
                    <span>{{ normalizeName(asset.name) }}</span>
                </div>
                <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-25 md-xsmall-size-30 asset-buttons">
                    <LoadAssetButton
                        :asset="asset"
                        :user="user" />

                    <DeleteAssetButton
                        :asset="asset"
                        :user="user" 
                        @asset-deleted="$emit('asset-deleted')"
                        />
                </div>
            </md-list-item>
        </md-list>
    </div>

</template>

<script>
import { AuthService } from "@/services/auth.service";
import { AreaService } from "@/services/area.service";
import { functions } from "@/firebaseFunctions.js"
import LoadAssetButton from "@/components/LoadAssetButton.vue";
import DeleteAssetButton from "@/components/DeleteAssetButton.vue";

export default {
    name: "AssetsList",
    components: {
        LoadAssetButton,
        DeleteAssetButton  
    },
    data: () => ({
        customAreas: [],
    }),
    props: {
        assetsList: {
            type: Array,
            required: true
        },
        user: {
            type: Object
        }
    },
    watch: {
        assetsList: {
            deep: true,
            immediate: true,
            handler: function(newVal) {
                return newVal
            }
        }
    },
    created() {
        this.authServiceSubscription = AuthService.loggedUser$.subscribe((user) => {
            this.prom = user;
        })
    },
    beforeDestroy() {
        this.authServiceSubscription.unsubscribe();
    },
    methods: {
        normalizeName(name){
            name = name.replace(/-/g, ' ');
            return name[0].toUpperCase() + name.substring(1);
        },
        getCustomAreas() {
            this.customAreas = AreaService.getCustomAreas();
        },
        loadAssetToMap(asset, area) {
            console.info("asked to map" , asset.name)
            // table is feature collection
            if(asset.type === "TABLE") {
                let data = {
                    "org_id": this.prom.orgId,
                    "user_id": this.prom.uid,
                    "asset_id": asset.id,
                }
                // gets mapURL and bbox
                try {
                    functions.getTable(data).then((response) => {
                        console.info("response", response)
                        let mapURL = response.data.mapURL
                        let bbox = response.data.bbox
                        AreaService.addUserUploadedShape(area, bbox, mapURL, asset.id)
                    })
                } catch(e) {
                    console.error(e)
                }
            }
        },
    }
}
</script>